import React from "react";
import { Button } from "react-bootstrap";
import { PRINT_KIND, printKindFor } from "./allocationPrintDocuments";

// Print action for one allocation row -- exactly ONE print button, chosen by
// status, so a returned allocation can never offer the allotment sheet:
//   Allocated -> "Print Allotment Sheet" (print icon)
//   Returned  -> "Print Return Sheet"    (receipt icon)
//   Cancelled -> no print action (a voided issue has no valid document)
export default function AllocationPrintActions({ row, onPrintAllotment, onPrintReturn }) {
  const kind = printKindFor(row);
  if (!kind) return null;

  if (kind === PRINT_KIND.RETURN) {
    return (
      <Button
        className="unit-icon-btn unit-invoice puws-action-btn invoice"
        title="Print Return Sheet"
        aria-label="Print return sheet"
        onClick={() => onPrintReturn(row)}
      >
        <i className="fa-solid fa-receipt" aria-hidden="true"></i>
      </Button>
    );
  }

  return (
    <Button
      className="unit-icon-btn unit-invoice puws-action-btn invoice"
      title="Print Allotment Sheet"
      aria-label="Print allotment sheet"
      onClick={() => onPrintAllotment(row)}
    >
      <i className="fa-solid fa-print" aria-hidden="true"></i>
    </Button>
  );
}
